import { useState } from 'react';

import DeleteConfirmModal from '../common/DeleteConfirmModal';
import LucideSymbolIcon from '../icons/LucideSymbolIcon';

type Props = {
  canDelete: boolean;
  label?: string;
  confirmTitle?: string;
  confirmMessage: string;
  onDelete: () => void | Promise<void>;
  disabled?: boolean;
  className?: string;
};

export default function AdminTableDeleteButton({
  canDelete,
  label = 'Supprimer',
  confirmTitle = 'Confirmer la suppression',
  confirmMessage,
  onDelete,
  disabled = false,
  className = '',
}: Props) {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [isConfirming, setIsConfirming] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  if (!canDelete) return null;

  const busy = disabled || isConfirming;

  return (
    <>
      <button
        type="button"
        disabled={busy}
        className={`academic-panel-btn academic-panel-btn--danger !inline-flex !px-2.5 !py-1.5 text-xs !gap-1.5 whitespace-nowrap disabled:opacity-50 ${className}`}
        onClick={() => {
          setErrorMessage(null);
          setConfirmOpen(true);
        }}
      >
        <LucideSymbolIcon name="delete" tone="inherit" size={14} />
        {label}
      </button>

      <DeleteConfirmModal
        open={confirmOpen}
        title={confirmTitle}
        description={confirmMessage}
        isConfirming={busy}
        errorMessage={errorMessage}
        onCancel={() => {
          if (!busy) setConfirmOpen(false);
        }}
        onConfirm={async () => {
          if (busy) return;
          setIsConfirming(true);
          setErrorMessage(null);
          try {
            await onDelete();
            setConfirmOpen(false);
          } catch (e) {
            setErrorMessage(e instanceof Error ? e.message : 'Suppression impossible.');
          } finally {
            setIsConfirming(false);
          }
        }}
      />
    </>
  );
}
